// @ts-nocheck
import { formBlockSchemaEnhancer } from '../components/Blocks/Form/schema';

import Button from '../components/Button/Button';

import Checkbox from '../components/Form/Checkbox/Checkbox';
import CheckboxField from '../components/Form/CheckboxField/CheckboxField';
import CheckboxGroup from '../components/Form/CheckboxGroup/CheckboxGroup';
import DatePicker from '../components/Form/DatePicker/DatePicker';
import FileSelector from '../components/Form/FileSelector/FileSelector';
import Radio from '../components/Form/Radio/Radio';
import RadioGroup from '../components/Form/RadioGroup/RadioGroup';
import Select from '../components/Form/Select/Select';
import TextAreaField from '../components/Form/TextAreaField/TextAreaField';
import TextField from '../components/Form/TextField/TextField';
import TimeField from '../components/Form/TimeField/TimeField';

import CheckboxWrapper from '@plone/volto-form-block/components/Wrappers/CheckboxWrapper';
import CheckboxGroupWrapper from '@plone/volto-form-block/components/Wrappers/CheckboxGroupWrapper';
import DatetimeWrapper from '@plone/volto-form-block/components/Wrappers/DatetimeWrapper';
import EmailWrapper from '@plone/volto-form-block/components/Wrappers/EmailWrapper';
import FileWrapper from '@plone/volto-form-block/components/Wrappers/FileWrapper';
import HiddenWrapper from '@plone/volto-form-block/components/Wrappers/HiddenWrapper';
import NumberWrapper from '@plone/volto-form-block/components/Wrappers/NumberWrapper';
import RadioGroupWrapper from '@plone/volto-form-block/components/Wrappers/RadioGroupWrapper';
import SelectWrapper from '@plone/volto-form-block/components/Wrappers/SelectWrapper';
import TextareaWrapper from '@plone/volto-form-block/components/Wrappers/TextareaWrapper';
import TextWrapper from '@plone/volto-form-block/components/Wrappers/TextWrapper';
import TimeWrapper from '@plone/volto-form-block/components/Wrappers/TimeWrapper';
import FormComponent from '@plone/volto-form-block/components/Wrappers/FormComponent';

import config from '@plone/volto/registry';

import { defineMessages } from 'react-intl';

import countries from './countries.json';

import {
  buildContactAllowedInitialData,
  buildDataprotectionInfoInitialData,
  buildPhonenumberInitialData,
} from './specialFormFields';

import { applyCaptchaDefault } from './captchaDefault';

const messages = defineMessages({
  termsAccepted: {
    id: 'termsAccepted',
    defaultMessage: 'Accept general terms',
  },
  country: {
    id: 'country',
    defaultMessage: 'Country',
  },
  gender: {
    id: 'gender',
    defaultMessage: 'Gender',
  },
  Female: {
    id: 'Female',
    defaultMessage: 'Female',
  },
  Male: {
    id: 'Male',
    defaultMessage: 'Male',
  },
  Other: {
    id: 'Other',
    defaultMessage: 'Other',
  },
  termsAcceptedValue: {
    id: 'I agree with the general terms and conditions',
    defaultMessage: 'I agree with the general terms and conditions',
  },
});

const ButtonWrapper = ({ primary, secondary, type, title, onClick }) => {
  return (
    <Button
      type={type === 'submit' ? 'submit' : 'button'}
      styles={secondary ? 'btn btn-secondary' : 'btn btn-primary'}
      onPress={onClick || (() => {})}
      label={title}
    />
  );
};

const Container = (props) => {
  return <>{children}</>;
};

const viewWrapper = (View) => (props) => {
  const components = { ...config.components };
  config.registerComponent({
    name: 'Container',
    component: Container,
  });
  const result = <View {...props} />;
  config.components = components;
  return result;
};

const schemaFormBlock = (config) => {
  config.registerUtility({
    name: 'termsAccepted',
    type: 'fieldFactoryProperties',
    method: (intl) => ({}),
  });

  config.registerUtility({
    name: 'termsAccepted',
    type: 'fieldFactoryInitialData',
    method: (intl) => ({
      type: 'boolean',
      required: true,
      factory: 'termsAccepted',
      title: intl.formatMessage(messages.termsAcceptedValue),
      id: 'terms-accepted',
    }),
  });

  config.registerUtility({
    name: 'country',
    type: 'fieldFactoryProperties',
    method: (intl) => ({}),
  });

  config.registerUtility({
    name: 'country',
    type: 'fieldFactoryInitialData',
    method: (intl) => ({
      type: 'string',
      factory: 'country',
      choices: countries[intl.locale].map((country) => [country, country]),
      id: 'country',
    }),
  });

  config.registerUtility({
    name: 'gender',
    type: 'fieldFactoryProperties',
    method: (intl) => ({}),
  });

  config.registerUtility({
    name: 'gender',
    type: 'fieldFactoryInitialData',
    method: (intl) => ({
      type: 'string',
      factory: 'gender',
      widget: 'radio_group',
      choices: [
        [
          intl.formatMessage(messages.Female),
          intl.formatMessage(messages.Female),
        ],
        [intl.formatMessage(messages.Male), intl.formatMessage(messages.Male)],
        [
          intl.formatMessage(messages.Other),
          intl.formatMessage(messages.Other),
        ],
      ],
      id: 'gender',
    }),
  });

  config.registerUtility({
    name: 'contactAllowed',
    type: 'fieldFactoryProperties',
    method: (intl) => ({}),
  });

  config.registerUtility({
    name: 'contactAllowed',
    type: 'fieldFactoryInitialData',
    method: buildContactAllowedInitialData,
  });

  config.registerUtility({
    name: 'dataprotectionInfo',
    type: 'fieldFactoryProperties',
    method: (intl) => ({}),
  });

  config.registerUtility({
    name: 'dataprotectionInfo',
    type: 'fieldFactoryInitialData',
    method: buildDataprotectionInfoInitialData,
  });

  config.registerUtility({
    name: 'phonenumber',
    type: 'fieldFactoryProperties',
    method: (intl) => ({}),
  });

  config.registerUtility({
    name: 'phonenumber',
    type: 'fieldFactoryInitialData',
    method: buildPhonenumberInitialData,
  });

  config.blocks.blocksConfig.schemaForm = {
    ...config.blocks.blocksConfig.schemaForm,
    view: viewWrapper(config.blocks.blocksConfig.schemaForm.view),
    edit: viewWrapper(config.blocks.blocksConfig.schemaForm.edit),
    defaultSender: 'noreply@fhnw.ch',
    defaultSenderName: 'FHNW',
    group: 'content',
    widgets: {
      ...config.widgets,
      widget: {
        ...config.widgets.widget,
        textarea: TextareaWrapper,
        file: FileWrapper,
        date: DatetimeWrapper,
        time: TimeWrapper,
        datetime: DatetimeWrapper,
        email: EmailWrapper,
        radio_group: RadioGroupWrapper,
        checkbox_group: CheckboxGroupWrapper,
        hidden: HiddenWrapper,
      },
      choices: SelectWrapper,
      type: {
        ...config.widgets.type,
        object: FileWrapper,
        date: DatetimeWrapper,
        datetime: DatetimeWrapper,
        number: NumberWrapper,
        integer: NumberWrapper,
        boolean: CheckboxWrapper,
      },
      default: TextWrapper,
    },
    // #1667: default the captcha provider on newly added forms so editors
    // don't ship unprotected forms. `initialValue` runs at block creation.
    initialValue: ({ value }) => applyCaptchaDefault(value),
    component: FormComponent,
    buttonComponent: ButtonWrapper,
    innerWidgets: {
      text: TextField,
      textarea: TextAreaField,
      file: FileSelector,
      date: DatePicker,
      datetime: DatePicker,
      time: TimeField,
      email: TextField,
      radioGroup: RadioGroup,
      radioGroupOption: Radio,
      number: TextField,
      checkbox: CheckboxField,
      checkboxGroup: CheckboxGroup,
      checkboxGroupOption: Checkbox,
      select: Select,
      hidden: TextField,
    },
    additionalFactory: [
      ...config.blocks.blocksConfig.schemaForm.additionalFactory,
      { value: 'termsAccepted', label: 'Accept general terms' },
      { value: 'country', label: 'Country' },
      { value: 'gender', label: 'Gender' },
      { value: 'contactAllowed', label: 'Contact allowed' },
      { value: 'dataprotectionInfo', label: 'Data protection info' },
      { value: 'phonenumber', label: 'Phone number' },
    ],
    filterFactory: [
      ...config.blocks.blocksConfig.schemaForm.filterFactory,
      'termsAccepted',
      'country',
      'gender',
      'contactAllowed',
      'dataprotectionInfo',
      'phonenumber',
    ],
    filterFactorySend: [
      ...config.blocks.blocksConfig.schemaForm.filterFactorySend,
      'dataprotectionInfo',
    ],
    schemaEnhancer: formBlockSchemaEnhancer,
  };

  return config;
};

export default schemaFormBlock;
